import styled from '@emotion/styled'
import { hexColors } from '@mobi/settings/hexColors'

export const SearchResultsStyled = styled.div({
  fontSize: '1.4rem',
})

export const SearchResultPrimaryInfoStyled = styled.span({
  fontSize: '1.2rem',
  display: 'block',
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis',
})

export const SearchResultSecondaryInfoStyled = styled.span({
  color: hexColors.dimGrey,
  display: 'block',
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis',
  fontSize: '1.0rem',
})

export const DriverStyled = styled(SearchResultSecondaryInfoStyled)({
  marginRight: '3px',
  display: 'inline',
})

export const RaceClassStyled = styled(SearchResultSecondaryInfoStyled)({
  display: 'inline',
})
export const RaceDistanceStyled = styled(RaceClassStyled)({
  marginRight: '3px',
})

export const SearchResultPricesStyled = styled.div({
  display: 'flex',
  fontWeight: 'bold',
  flexDirection: 'column',
})

export const SearchResultInfoHeaderStyled = styled.div({
  backgroundColor: hexColors.white,
  borderBottom: `1px solid ${hexColors.gainsboro}`,
  textAlign: 'right',
  padding: '0.25rem 1rem',
})

export const SearchFixedOddsLabelStyled = styled.span({
  fontSize: '1.2rem',
  fontWeight: 'bold',
  color: hexColors.scooter,
})
